module.exports = __webpack_public_path__ + "static/media/3 6 49.e07ad2cc.png";